import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormConfigService } from 'src/app/form-config/form-config.service';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UiKitModule } from 'src/app/ui-kit/ui-kit.module';
import { UnderlyingAssetsModalComponent } from './underlying-assets-modal.component';
import { UnderlyingAssetsModalService } from './underlying-assets-modal.service';
import { FilterAssetsPipe } from './pipes/filter-assets.pipe';
import { FilterPerformanceTypePipe } from './pipes/filter-performance-type.pipe';
import { FilterFxAssetsPipe } from './pipes/filter-fx-assets.pipe';

@NgModule({
  declarations: [
    UnderlyingAssetsModalComponent,
    FilterAssetsPipe,
    FilterFxAssetsPipe,
  ],
  imports: [
    CommonModule,
    NgbModule,
    UiKitModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
  ],
  providers: [UnderlyingAssetsModalService, FormConfigService],
})
export class UnderlyingAssetsModalModule {}
